module.exports = __webpack_public_path__ + "img/img40.41a121ba.png";